import axios from "axios";
import { apiHttp, API_URL_BACKEND } from "../axiosApi.js";
import {
  allLocation,
  contactUs,
  creditNote,
  invoice,
  invoiceCleanUp,
  liquidProduct,
  order,
  postLocation,
  postulateLocation,
  providerProforma,
  providerProformaById,
  providerProformaInvoice,
  receipt,
} from "../config/apiRoute.js";

export const getLocationsAPI = (limit = 5, from = 0) => {
  return apiHttp("GET", `${postLocation}?limit=${limit}&from=${from}`);
};
export const getLocalityAPI = (limit = 5, from = 0) => {
  return apiHttp("GET", `${postLocation}/locality`);
};

export const getLocationsAPIAll = () => {
  return apiHttp("GET", `${postLocation}`);
};

export const getLocationsAPISelectAll = () => {
  return apiHttp("GET", `${postLocation}/All`);
};

export const getLocationsToPostulate = async () => {
  try {
    const { data } = await apiHttp("GET", `${postulateLocation}`);
    return data;
  } catch (error) {
    console.error("errorLocations", error);
  }
};

export const getAllLocations = async () => {
  try {
    const { data } = await apiHttp("GET", `${allLocation}`);
    return data;
  } catch (error) {
    console.error("errorLocations", error);
  }
};

export const getLocationByIdAPI = (id) =>
  apiHttp("GET", `${postLocation}/${id}`);

export const postLocationAPI = (body) =>
  apiHttp("POST", `${postLocation}`, body);
export const postInvoice = (body) => apiHttp("POST", `${invoice}`, body);
export const postInvoiceRetry = (id) => apiHttp("POST", `${invoice}/${id}/retry`, {});
export const postInvoiceCleanUp = (body) =>
  apiHttp("POST", `${invoice}${invoiceCleanUp}`, body);
export const postCreditNote = (body) => apiHttp("POST", `${creditNote}`, body);
export const postProviderProforma = (body) =>
  apiHttp("POST", `${providerProforma}`, body);
export const patchProviderProforma = (id, body) =>
  apiHttp("PATCH", `${providerProformaById(id)}`, body);
export const patchProviderProformaInvoice = async (id, formData) => {
  const token = localStorage?.token;
  try {
    const { data } = await axios.patch(
      `${API_URL_BACKEND}${providerProformaInvoice(id)}`,
      formData,
      {
        headers: {
          Accept: "application/json",
          Authorization: `${token}`,
          device: "WEB",
        },
      }
    );
    return data;
  } catch (error) {
    return {
      status: error.response?.status || 0,
      msg:
        error.response?.data?.msg ||
        error.response?.data?.errors?.[0]?.msg ||
        "Internal error",
    };
  }
};

export const postReceipt = (body) => apiHttp("POST", `${receipt}`, body);
export const postOrder = (body) => apiHttp("POST", `${order}`, body);

export const postLp = (body) => apiHttp("POST", `${liquidProduct}`, body);

export const getInovoice = (id) => apiHttp("GET", `${invoice}/${id}`);

export const putLocationByIdAPI = (id, body) =>
  apiHttp("PUT", `${postLocation}/${id}`, body);

export const delLocationByIdAPI = (id) =>
  apiHttp("DELETE", `${postLocation}/${id}`);

export const postContactUs = (body) => apiHttp("POST", `${contactUs}`, body);
